export type AlignmentType = 'left' | 'right' | 'center';

export const AlignmentEnum = {
  left: 'left',
  right: 'right',
  center: 'center',
};
